"use strict";

module.exports = function (accumulator, order, product, component) {
  var rounded_quantity = 1;
  var up = parseInt(component.up, 10);
  return "".concat(rounded_quantity, " (").concat(up, "up, 1 copy)");
};